{
  "_comment": "WaveTalk web (Joana) — Kiswahili (sw). GENERATED by scripts/i18n-apply.mjs from i18n/translations/sw.json; edit that file, not this one. The key is the English text.",
  "%d people": "Watu %d",
  "%d zones": "Maeneo %d",
  "%s added %s": "%s ameongeza %s",
  "%s added you": "%s amekuongeza",
  "%s allowed all members to edit the group info": "%s ameruhusu wanachama wote kuhariri taarifa za kikundi",
  "%s and %s": "%s na %s",
  "%s changed the group description": "%s amebadilisha maelezo ya kikundi",
  "%s changed the group icon": "%s amebadilisha picha ya kikundi",
  "%s changed the group name to “%s”": "%s amebadilisha jina la kikundi kuwa “%s”",
  "%s left": "%s ameondoka",
  "%s made %s a moderator": "%s amemfanya %s mratibu",
  "%s made %s an admin": "%s amemfanya %s msimamizi",
  "%s made you a moderator": "%s amekufanya mratibu",
  "%s made you an admin": "%s amekufanya msimamizi",
  "%s must update WaveTalk before anyone can write here": "Hakuna anayeweza kuandika hapa hadi WaveTalk isasishwe: %s",
  "%s removed %s": "%s ameondoa %s",
  "%s removed %s as an admin": "%s amemwondoa %s kwenye usimamizi",
  "%s removed the group description": "%s ameondoa maelezo ya kikundi",
  "%s removed the group icon": "%s ameondoa picha ya kikundi",
  "%s removed you": "%s amekuondoa",
  "%s removed you as an admin": "%s amekuondoa kwenye usimamizi",
  "%s requests": "%s inaomba",
  "%s restricted editing the group info to admins": "%s amezuia kuhariri taarifa za kikundi kwa wasimamizi pekee",
  "%s turned off disappearing messages": "%s amezima jumbe zinazotoweka",
  "%s turned on disappearing messages: %s": "%s amewasha jumbe zinazotoweka: %s",
  "%s updated WaveTalk. Messages here are end-to-end encrypted.": "%s amesasisha WaveTalk. Jumbe hapa zimesimbwa mwanzo hadi mwisho.",
  "%s, %s": "%s, %s",
  "+ Hide from someone…": "+ Ficha kwa mtu fulani…",
  "1 person": "Mtu 1",
  "1 zone": "Eneo 1",
  "24 hours": "Saa 24",
  "6-digit code": "Msimbo wa tarakimu 6",
  "7 days": "Siku 7",
  "90 days": "Siku 90",
  "A channel is an account that broadcasts — a shop, a station, a church, an office. People follow it and see what you post on their Updates. Nobody can reply.": "Chaneli ni akaunti inayotangaza — duka, kituo cha redio, kanisa, ofisi. Watu wanaifuata na kuona unachochapisha kwenye Mapya yao. Hakuna anayeweza kujibu.",
  "A language arrives complete or not at all.": "Lugha huja ikiwa kamili au haiji kabisa.",
  "A post stays until you delete it. Only the people you choose can see it, and it is not end-to-end encrypted.": "Chapisho hubaki hadi ulifute. Ni watu unaowachagua pekee wanaoweza kuliona, na halijasimbwa mwanzo hadi mwisho.",
  "Activity": "Shughuli",
  "Add a comment": "Ongeza maoni",
  "Add status": "Ongeza hali",
  "Admin": "Msimamizi",
  "Airtel Money": "Airtel Money",
  "All": "Zote",
  "An organisation is a shop, a church committee, a school or an NGO — the people you work with, and the conversations that belong to the group rather than to whoever started them.": "Shirika ni duka, kamati ya kanisa, shule au shirika lisilo la kiserikali — watu unaofanya nao kazi, na mazungumzo yanayolimilikiwa na kikundi badala ya yule aliyeyaanzisha.",
  "Anyone who finds you, including in search": "Yeyote anayekupata, ikiwa ni pamoja na kwenye utafutaji",
  "Appearance": "Muonekano",
  "Audio": "Sauti",
  "Build": "Ujenzi",
  "Built-in": "Ya ndani",
  "Call cancelled: %s": "Simu imefutwa: %s",
  "Call scheduled: %s": "Simu imepangwa: %s",
  "Cancel": "Ghairi",
  "Channel": "Chaneli",
  "Channels": "Chaneli",
  "Channels you follow": "Chaneli unazozifuata",
  "Chat wallpaper": "Mandhari ya gumzo",
  "Chats": "Gumzo",
  "Choose a conversation to start.": "Chagua mazungumzo kuanza.",
  "Choose photo…": "Chagua picha…",
  "Chosen groups": "Vikundi vilivyochaguliwa",
  "Circle": "Wangu",
  "Close": "Funga",
  "Colour": "Rangi",
  "Coming: %s": "Inakuja: %s",
  "Comment": "Maoni",
  "Compare this number with your contact's, in person or over a call you trust. If they match, your conversation is end-to-end encrypted and no one in the middle can read it.": "Linganisha namba hii na ya mwenzako, mkiwa ana kwa ana au kwenye simu unayoiamini. Zikifanana, mazungumzo yenu yamesimbwa mwanzo hadi mwisho na hakuna aliye katikati anayeweza kuyasoma.",
  "Confirm on your phone": "Thibitisha kwenye simu yako",
  "Confirm payment": "Thibitisha malipo",
  "Connecting…": "Inaunganisha…",
  "Contact": "Anwani",
  "Contact email": "Barua pepe ya mawasiliano",
  "Contact phone": "Simu ya mawasiliano",
  "Could not change that. Try again.": "Imeshindwa kubadilisha hilo. Jaribu tena.",
  "Could not load channels.": "Imeshindwa kupakia chaneli.",
  "Could not load this channel.": "Imeshindwa kupakia chaneli hii.",
  "Couldn't change who can see your status.": "Haikuweza kubadilisha nani anaweza kuona hali yako.",
  "Couldn't delete that comment.": "Haikuweza kufuta maoni hayo.",
  "Couldn't delete that post.": "Haikuweza kufuta chapisho hilo.",
  "Couldn't delete that.": "Haikuweza kufuta hilo.",
  "Couldn't load that list.": "Haikuweza kupakia orodha hiyo.",
  "Couldn't load the frames.": "Haikuweza kupakia fremu.",
  "Couldn't load the sticker pack.": "Haikuweza kupakia pakiti ya vibandiko.",
  "Couldn't load your channels.": "Haikuweza kupakia chaneli zako.",
  "Couldn't mute that person.": "Haikuweza kunyamazisha mtu huyo.",
  "Couldn't open that thread.": "Imeshindwa kufungua mfululizo huo.",
  "Couldn't post that comment.": "Haikuweza kutuma maoni hayo.",
  "Couldn't post that status.": "Haikuweza kuweka hali hiyo.",
  "Couldn't publish that post.": "Haikuweza kuchapisha chapisho hilo.",
  "Couldn't send the report. Try again.": "Imeshindwa kutuma ripoti. Jaribu tena.",
  "Create": "Tengeneza",
  "Create a channel": "Tengeneza chaneli",
  "Create an organisation": "Unda shirika",
  "Create organisation": "Unda shirika",
  "Create zone": "Unda eneo",
  "Creating…": "Inatengeneza…",
  "Current": "Ya sasa",
  "Dark": "Nyeusi",
  "Delete": "Futa",
  "Discover": "Gundua",
  "Done": "Imekamilika",
  "Earlier photo": "Picha ya awali",
  "Enter your username and password": "Weka jina lako la mtumiaji na nenosiri",
  "Enter your verification code": "Weka msimbo wako wa uthibitisho",
  "Everyone": "Kila mtu",
  "Explicit content": "Maudhui ya matusi",
  "Explore": "Chunguza",
  "Explore all channels": "Chunguza chaneli zote",
  "Failed to load": "Imeshindwa kupakia",
  "Featured": "Zilizoangaziwa",
  "File": "Faili",
  "Fill in everything above first.": "Jaza kila kitu hapo juu kwanza.",
  "Find channels to follow": "Tafuta chaneli za kufuata",
  "Follow": "Fuata",
  "Follow my browser": "Fuata kivinjari changu",
  "Follow my device": "Fuata kifaa changu",
  "Following": "Ninaifuata",
  "For you": "Kwa ajili yako",
  "Frame": "Fremu",
  "Frame…": "Fremu…",
  "Fri": "Ijm",
  "From here, messages in this chat are end-to-end encrypted": "Kuanzia hapa, jumbe za gumzo hili zimesimbwa mwanzo hadi mwisho",
  "Generating code…": "Inatengeneza msimbo…",
  "Get a new code": "Pata msimbo mpya",
  "Ghost · 24h": "Kivuli · saa 24",
  "Group call": "Simu ya kikundi",
  "Group call · %s": "Simu ya kikundi · %s",
  "Group video call": "Simu ya video ya kikundi",
  "Group video call · %s": "Simu ya video ya kikundi · %s",
  "Handle": "Kitambulisho",
  "Handle: @%s. This cannot be changed later.": "Kitambulisho: @%s. Hakiwezi kubadilishwa baadaye.",
  "Harassment or bullying": "Unyanyasaji au uonevu",
  "Hide your photo from…": "Ficha picha yako kwa…",
  "Hide your photo from… (name, @username, or phone)": "Ficha picha yako kwa… (jina, @jina la mtumiaji au namba ya simu)",
  "In %d organisations": "Katika mashirika %d",
  "Indigo": "Nili",
  "Installed": "Imesakinishwa",
  "Language": "Lugha",
  "Leave organisation": "Ondoka kwenye shirika",
  "Let somebody scan this to message you.": "Mwache mtu achanganue hii ili akutumie ujumbe.",
  "Light": "Nyeupe",
  "Liked": "Umependa",
  "Loading mini-apps…": "Inapakia programu ndogo…",
  "Loading…": "Inapakia…",
  "M-Pesa": "M-Pesa",
  "Make admin": "Mfanye msimamizi",
  "Mazungumzo": "Mazungumzo",
  "Member": "Mwanachama",
  "Mentions": "Kutajwa",
  "Message": "Ujumbe",
  "Message failed to send": "Ujumbe haukutumwa",
  "Messages in this chat aren't end-to-end encrypted.": "Jumbe za gumzo hili hazijasimbwa mwanzo hadi mwisho.",
  "Mini-app": "Programu ndogo",
  "Mini-apps": "Programu ndogo",
  "Mixx by Yas": "Mixx by Yas",
  "Mon": "Jtat",
  "Mute": "Nyamazisha",
  "My QR code": "Msimbo wangu wa QR",
  "My status": "Hali yangu",
  "Name": "Jina",
  "Never sent a message": "Haijawahi kutuma ujumbe",
  "New channel": "Chaneli mpya",
  "New organisation": "Shirika jipya",
  "New post": "Chapisho jipya",
  "New status": "Hali mpya",
  "New zone": "Eneo jipya",
  "No channels yet. When publishers arrive, they show up here.": "Bado hakuna chaneli. Wachapishaji watakapofika, wataonekana hapa.",
  "No connection": "Hakuna muunganisho",
  "No conversations yet": "Bado hakuna mazungumzo",
  "No installed apps yet": "Bado hakuna programu zilizosakinishwa",
  "No messages yet": "Bado hakuna jumbe",
  "No mini-apps available yet": "Bado hakuna programu ndogo zilizopo",
  "No safety number yet — it appears once you've exchanged an encrypted message with this contact.": "Bado hakuna namba ya usalama — huonekana baada ya kubadilishana ujumbe uliosimbwa na anwani hii.",
  "No views yet": "Bado hakuna waliotazama",
  "No zones yet.": "Bado hakuna maeneo.",
  "Nobody": "Hakuna mtu",
  "Nobody has said anything in public yet. When they do, it shows up here.": "Bado hakuna aliyesema chochote hadharani. Watakaposema, kitaonekana hapa.",
  "None": "Hakuna",
  "Not on WaveTalk": "Hayupo WaveTalk",
  "Not publishing": "Haichapishi",
  "Not used recently": "Haijatumika hivi karibuni",
  "Nothing found.": "Hakuna kilichopatikana.",
  "Nothing liked yet.": "Bado hakuna ulichokipenda.",
  "Nothing posted yet.": "Bado hakuna kilichochapishwa.",
  "Nothing posted yet. Write one, and the people you chat with will see it.": "Bado hakuna kilichochapishwa. Andika kimoja, na watu unaozungumza nao wataona.",
  "Nothing saved yet.": "Bado hakuna ulichohifadhi.",
  "Nothing up right now. A status disappears after 24 hours.": "Hakuna kilichowekwa kwa sasa. Hali hutoweka baada ya saa 24.",
  "Nothing yet from the people you follow.": "Bado hakuna kitu kutoka kwa watu unaowafuata.",
  "Nothing yet.": "Bado hakuna kitu.",
  "Notification": "Arifa",
  "OK": "Sawa",
  "Office": "Ofisi",
  "Office zone. WaveTalk's servers can read this zone so an assistant can take part. It is not end-to-end encrypted.": "Eneo la ofisi. Seva za WaveTalk zinaweza kusoma eneo hili ili msaidizi aweze kushiriki. Halijalindwa mwisho-hadi-mwisho.",
  "Office — your channels": "Ofisi — chaneli zako",
  "One line, shown in Explore": "Mstari mmoja, unaonyeshwa kwenye Chunguza",
  "Online": "Mtandaoni",
  "Only me": "Mimi pekee",
  "Only people you have replied to in a direct chat": "Ni watu uliowahi kuwajibu kwenye gumzo la moja kwa moja pekee",
  "Only share with…": "Shiriki tu na…",
  "Only the people I picked": "Ni watu niliowachagua pekee",
  "Only the people you choose can see this. Status is not end-to-end encrypted.": "Ni watu unaowachagua pekee wanaoweza kuona hii. Hali haijasimbwa mwanzo hadi mwisho.",
  "Only you": "Wewe pekee",
  "Open WaveTalk on your phone → Settings → Scan to log in": "Fungua WaveTalk kwenye simu yako → Mipangilio → Skani ili kuingia",
  "Ops": "Uendeshaji",
  "Organisation name": "Jina la shirika",
  "Organisations": "Mashirika",
  "Owner": "Mmiliki",
  "Password": "Nenosiri",
  "Pay %s %s": "Lipa %s %s",
  "Pay with": "Lipa kwa",
  "People": "Watu",
  "People I chat with": "Watu ninaozungumza nao",
  "People can follow this and see what you post.": "Watu wanaweza kuifuata na kuona unachochapisha.",
  "People you follow": "Watu unaowafuata",
  "Phone number (e.g. 0712 345 678)": "Namba ya simu (mfano 0712 345 678)",
  "Photo": "Picha",
  "Photo history — only you see this": "Historia ya picha — wewe pekee unaiona",
  "Photo history…": "Historia ya picha…",
  "Pick a sticker": "Chagua kibandiko",
  "Pick an emoji": "Chagua emoji",
  "Plain": "Sahili",
  "Post": "Chapisha",
  "Post comment": "Tuma maoni",
  "Posting…": "Inachapisha…",
  "Posts": "Machapisho",
  "Pretending to be someone else": "Kujifanya mtu mwingine",
  "Processing…": "Inashughulikia…",
  "Profile": "Wasifu",
  "Profile photo": "Picha ya wasifu",
  "Publish to people who follow you": "Chapisha kwa watu wanaokufuata",
  "Publishing": "Inachapisha",
  "Publishing is off, so nobody can follow this yet.": "Uchapishaji umezimwa, hivyo bado hakuna anayeweza kuifuata.",
  "Quote": "Nukuu",
  "Remove": "Ondoa",
  "Remove as admin": "Mwondoe kwenye usimamizi",
  "Remove photo": "Ondoa picha",
  "Rename": "Badili jina",
  "Reply": "Jibu",
  "Report": "Ripoti",
  "Reported. Thank you — we'll review it.": "Imeripotiwa. Asante — tutaikagua.",
  "Repost": "Chapisha upya",
  "Right now that is %s": "Kwa sasa ni %s",
  "Right now the only way anyone can find you is by typing @%s exactly. Add the name people actually call you and they will find you by that instead.": "Kwa sasa njia pekee ya mtu kukupata ni kuandika @%s hasa hivyo. Weka jina ambalo watu wanakuita nalo, nao watakupata kwa jina hilo.",
  "Rose": "Waridi",
  "Sales": "Mauzo",
  "Sand": "Mchanga",
  "Sat": "Jmos",
  "Save": "Hifadhi",
  "Saved": "Imehifadhiwa",
  "Saved in this browser. We will sync it to your account when you are back online.": "Imehifadhiwa kwenye kivinjari hiki. Tutaisawazisha na akaunti yako utakaporejea mtandaoni.",
  "Say hello 👋": "Sema salamu 👋",
  "Scam or fraud": "Ulaghai au utapeli",
  "Scan with WaveTalk on your phone": "Skani kwa WaveTalk kwenye simu yako",
  "Scan with phone instead": "Skani kwa simu badala yake",
  "Search": "Tafuta",
  "Search Mazungumzo": "Tafuta kwenye Mazungumzo",
  "Search channels": "Tafuta chaneli",
  "Search mini-apps": "Tafuta programu ndogo",
  "Send": "Tuma",
  "Session": "Kipindi",
  "Sign in": "Ingia",
  "Sign in with password instead": "Ingia kwa nenosiri badala yake",
  "Sign out": "Toka",
  "Sign-in was declined on your phone": "Kuingia kumekataliwa kwenye simu yako",
  "Signing in…": "Inaingia…",
  "Slate": "Kijivu",
  "Someone": "Mtu fulani",
  "Someone who has your number in their contacts can find you": "Mtu mwenye namba yako kwenye anwani zake anaweza kukupata",
  "Something else": "Jambo lingine",
  "Spam": "Taka",
  "Starting camera…": "Inawasha kamera…",
  "Sticker": "Kibandiko",
  "Support": "Msaada",
  "Syncing your chats…": "Inasawazisha mazungumzo yako…",
  "Syncing your chats… %s%": "Inasawazisha mazungumzo yako… %s%",
  "Teal": "Kijani bahari",
  "That didn't work. Try again.": "Haikufanya kazi. Jaribu tena.",
  "That handle is already taken. Try another.": "Kitambulisho hicho kimeshachukuliwa. Jaribu kingine.",
  "That post wasn't published.": "Chapisho hilo halikuchapishwa.",
  "The handle is unique and permanent. Lower case, no spaces.": "Kitambulisho ni cha kipekee na cha kudumu. Herufi ndogo, bila nafasi.",
  "The language WaveTalk is read in": "Lugha ambayo WaveTalk husomwa kwayo",
  "This browser is not a linked device, so it cannot read this chat. Open WaveTalk on your phone → Settings → Scan to log in.": "Kivinjari hiki si kifaa kilichounganishwa, hivyo hakiwezi kusoma gumzo hili. Fungua WaveTalk kwenye simu yako → Mipangilio → Changanua ili kuingia.",
  "This changes WaveTalk only.": "Hii inabadilisha WaveTalk pekee.",
  "This channel has not posted yet.": "Chaneli hii bado haijachapisha chochote.",
  "This chat is end-to-end encrypted. You can only read and write it on your phone.": "Gumzo hili limesimbwa mwanzo hadi mwisho. Unaweza kulisoma na kuliandika kwenye simu yako pekee.",
  "This code expired": "Msimbo huu umeisha muda",
  "This is remembered in this browser, not on your account — a bright desk and a dark phone want different answers.": "Hii inakumbukwa kwenye kivinjari hiki, si kwenye akaunti yako — meza yenye mwanga na simu yenye giza zinahitaji majibu tofauti.",
  "This message can't be read on this device": "Ujumbe huu hauwezi kusomwa kwenye kifaa hiki",
  "This message was deleted": "Ujumbe huu ulifutwa",
  "This number is for this browser and %s's device %s. Each device has its own key, so your phone shows a different number for the same person.": "Namba hii ni ya kivinjari hiki na ya %s, kifaa namba %s. Kila kifaa kina ufunguo wake, hivyo simu yako huonyesha namba tofauti kwa mtu yule yule.",
  "This post is no longer available.": "Chapisho hili halipatikani tena.",
  "Thu": "Alh",
  "Tue": "Jnne",
  "Type a status": "Andika hali",
  "Update WaveTalk to keep chatting here": "Sasisha WaveTalk ili uendelee kuzungumza hapa",
  "Updates": "Mapya",
  "Use": "Tumia",
  "Use a sticker…": "Tumia kibandiko…",
  "Use an emoji…": "Tumia emoji…",
  "Username or phone": "Jina la mtumiaji au namba ya simu",
  "Verify": "Thibitisha",
  "Verify security": "Thibitisha usalama",
  "Verifying…": "Inathibitisha…",
  "Video": "Video",
  "Voice": "Sauti",
  "Voice note": "Dokezo la sauti",
  "WaveTalk": "WaveTalk",
  "WaveTalk on your computer": "WaveTalk kwenye kompyuta yako",
  "Wed": "Jtan",
  "What does it trade in?": "Inafanya biashara ya nini?",
  "What is it? (optional)": "Ni nini? (si lazima)",
  "What is this zone for?": "Eneo hili ni la nini?",
  "What kind of publisher is this?": "Huyu ni mchapishaji wa aina gani?",
  "What people see": "Kile watu wanachokiona",
  "What's being said": "Kinachosemwa",
  "What's happening?": "Kuna nini?",
  "When this is set to Nobody, someone typing your number finds nothing — the same as if you had never registered. Your name and @handle can still be searched.": "Ukiweka Hakuna, mtu anayeandika namba yako hapati chochote — sawa na kama hujawahi kujisajili. Jina lako na @jina bado vinaweza kutafutwa.",
  "Who can find me by my phone number": "Nani anaweza kunipata kwa namba yangu ya simu",
  "Who can see it": "Nani anaweza kuiona",
  "Who can see your photo": "Nani anaweza kuona picha yako",
  "Why are you reporting this?": "Kwa nini unaripoti hili?",
  "Work together in one place": "Fanyeni kazi pamoja sehemu moja",
  "World": "Duniani",
  "Write to your followers": "Andika kwa wafuasi wako",
  "Yesterday": "Jana",
  "You added %s": "Umeongeza %s",
  "You allowed all members to edit the group info": "Umeruhusu wanachama wote kuhariri taarifa za kikundi",
  "You can read this chat here, but sending is only on your phone for now.": "Unaweza kusoma gumzo hili hapa, lakini kutuma ni kwenye simu yako pekee kwa sasa.",
  "You changed the group description": "Umebadilisha maelezo ya kikundi",
  "You changed the group icon": "Umebadilisha picha ya kikundi",
  "You changed the group name to “%s”": "Umebadilisha jina la kikundi kuwa “%s”",
  "You left": "Umeondoka",
  "You made %s a moderator": "Umemfanya %s mratibu",
  "You made %s an admin": "Umemfanya %s msimamizi",
  "You removed %s": "Umeondoa %s",
  "You removed %s as an admin": "Umemwondoa %s kwenye usimamizi",
  "You removed the group description": "Umeondoa maelezo ya kikundi",
  "You removed the group icon": "Umeondoa picha ya kikundi",
  "You restricted editing the group info to admins": "Umezuia kuhariri taarifa za kikundi kwa wasimamizi pekee",
  "You turned off disappearing messages": "Umezima jumbe zinazotoweka",
  "You turned on disappearing messages: %s": "Umewasha jumbe zinazotoweka: %s",
  "You updated WaveTalk. Messages here are end-to-end encrypted.": "Umesasisha WaveTalk. Jumbe hapa zimesimbwa mwanzo hadi mwisho.",
  "%s created the zone “%s”. It is not end-to-end encrypted: WaveTalk's servers can read it so an assistant can take part.": "%s ameunda eneo “%s”. Halijasimbwa mwanzo hadi mwisho: seva za WaveTalk zinaweza kulisoma ili msaidizi aweze kushiriki.",
  "You're offline — a post has to reach people.": "Upo nje ya mtandao — chapisho lazima liwafikie watu.",
  "You're offline — a status has to reach people.": "Upo nje ya mtandao — hali lazima iwafikie watu.",
  "You're offline. A post has to reach your followers, so it waits.": "Huna muunganisho. Chapisho lazima liwafikie wafuasi wako, kwa hivyo linasubiri.",
  "Your channels": "Chaneli zako",
  "Your name": "Jina lako",
  "Your number finds nothing, as if you had never registered": "Namba yako haipati chochote, kama vile hujawahi kujisajili",
  "Your photo is not end-to-end encrypted — the WaveTalk service stores it so it can be shown to people you chat with.": "Picha yako haijasimbwa mwanzo hadi mwisho — huduma ya WaveTalk huihifadhi ili ionyeshwe kwa watu unaozungumza nao.",
  "Zone": "Eneo",
  "Zone name": "Jina la eneo",
  "Zones": "Maeneo",
  "just now": "sasa hivi",
  "quoted you": "amekunukuu",
  "replied to you": "amekujibu",
  "reposted you": "amechapisha tena chapisho lako",
  "typing…": "anaandika…",
  "unique, permanent": "ya kipekee, ya kudumu",
  "‹ Back": "‹ Rudi",
  "← Thread": "← Uzi",
  "⊞ Apps": "⊞ Programu",
  "◉ Capture": "◉ Piga",
  "◌ Updates": "◌ Mapya",
  "◍ Updates": "◍ Mapya",
  "♡ Like": "♡ Penda",
  "♥ Liked": "♥ Umependa",
  "✓ Scanned": "✓ Imeskaniwa",
  "✕ Close": "✕ Funga",
  "🔗 Linked device": "🔗 Kifaa kilichounganishwa",
  "Update WaveTalk to keep using it": "Sasisha WaveTalk ili uendelee kuitumia",
  "Update WaveTalk to open this zone": "Sasisha WaveTalk ili ufungue eneo hili",
  "This zone needs a newer version of WaveTalk. Your other chats work as usual.": "Eneo hili linahitaji toleo jipya la WaveTalk. Mazungumzo yako mengine yanaendelea kama kawaida.",
  "This version is no longer supported. Install the latest one to send and receive messages again.": "Toleo hili halitumiki tena. Sakinisha la karibuni ili uweze kutuma na kupokea ujumbe tena.",
  "Reload WaveTalk": "Pakia upya WaveTalk",
  "Signing you in…": "Inakuingiza…",
  "Couldn't reach WaveTalk. Check your connection and reload, or sign in below.": "Imeshindwa kufikia WaveTalk. Angalia muunganisho wako na upakie upya, au ingia hapa chini.",
  "Sign in to keep talking": "Ingia ili uendelee kuzungumza",
  "1 follower": "Mfuasi 1",
  "%d followers": "Wafuasi %d",
  "Today": "Leo",
  "Unknown": "Haijulikani",
  "Unmute": "Ondoa unyamazishaji",
  "Load older posts": "Pakia machapisho ya zamani",
  "Forward to": "Sambaza kwa",
  "Forwarded.": "Imesambazwa.",
  "Couldn't forward.": "Imeshindwa kusambaza.",
  "Couldn't react. Try again.": "Imeshindwa kujibu. Jaribu tena.",
  "%d days": "Siku %d",
  "A key lets a tool act as this organisation's assistant, only in zones where the assistant is on. Every use is recorded.": "Ufunguo humruhusu chombo kufanya kazi kama msaidizi wa shirika hili, katika maeneo ambayo msaidizi amewashwa tu. Kila matumizi yanarekodiwa.",
  "API keys": "Funguo za API",
  "Add assistant": "Ongeza msaidizi",
  "Add": "Ongeza",
  "An assistant can read the zones you switch it on in, and post there through a tool you give an API key. It is not a person and never signs in.": "Msaidizi anaweza kusoma maeneo unayomwashia, na kutuma humo kupitia chombo unachokipa ufunguo wa API. Si mtu, na haingii kwenye akaunti kamwe.",
  "Assistant in %s": "Msaidizi katika %s",
  "Assistant in this zone": "Msaidizi katika eneo hili",
  "Assistant name": "Jina la msaidizi",
  "Assistant": "Msaidizi",
  "Copied.": "Umenakiliwa.",
  "Copy it now. You will not see this key again.": "Unakili sasa. Hutauona ufunguo huu tena.",
  "Copy": "Nakili",
  "Expires %s": "Unaisha %s",
  "For example: Ideas, Support": "Kwa mfano: Mawazo, Huduma",
  "Instructions": "Maelekezo",
  "Issue an API key": "Toa ufunguo wa API",
  "Issue": "Toa",
  "Key name": "Jina la ufunguo",
  "Last used %s": "Ulitumika mwisho %s",
  "Lasts": "Unadumu",
  "Never used": "Haujawahi kutumika",
  "Off": "Imezimwa",
  "On": "Imewashwa",
  "On, as %s": "Amewashwa, kama %s",
  "Switched off": "Amezimwa",
  "Switched on": "Amewashwa",
  "Post in zones": "Kutuma katika maeneo",
  "Read zones": "Kusoma maeneo",
  "Refused %d times — check where it is used": "Ulikataliwa mara %d — angalia unapotumika",
  "Refused once — check where it is used": "Ulikataliwa mara moja — angalia unapotumika",
  "Revoke “%s”? Anything using it stops working at once.": "Batilisha “%s”? Chochote kinachoutumia kitaacha kufanya kazi mara moja.",
  "Revoke": "Batilisha",
  "Revoked %s": "Ulibatilishwa %s",
  "Shape": "Jukumu",
  "Tap to rename": "Gusa kubadilisha jina",
  "The assistant belongs to this organisation. It has no phone number, never signs in, and reads only the zones you switch it on in.": "Msaidizi ni wa shirika hili. Hana namba ya simu, haingii kwenye akaunti kamwe, na husoma maeneo unayomwashia tu.",
  "What will use it": "Kitakachoutumia",
  "When it is on, the assistant is a member of this zone and can read it. Everyone in the zone sees it join or leave.": "Akiwashwa, msaidizi anakuwa mwanachama wa eneo hili na anaweza kulisoma. Kila mtu katika eneo ataona akijiunga au akiondoka.",
  "Your new API key": "Ufunguo wako mpya wa API",
  "%s Assistant": "Msaidizi wa %s",
  "Couldn't load that organisation.": "Imeshindwa kupakia shirika hilo.",
  "Couldn't load your organisations.": "Imeshindwa kupakia mashirika yako.",
  "That change wasn't made.": "Badiliko hilo halikufanyika.",
  "That organisation wasn't created.": "Shirika hilo halikuundwa.",
  "You couldn't leave that organisation.": "Hukuweza kuondoka kwenye shirika hilo.",
  "You're offline.": "Huko mtandaoni."
}
